// Dates for the panel: "5 min ago" in lists, the full date on hover and in
// exports.

const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

const STEPS = [
  ["year", 365 * 24 * 3600],
  ["month", 30 * 24 * 3600],
  ["week", 7 * 24 * 3600],
  ["day", 24 * 3600],
  ["hour", 3600],
  ["minute", 60],
];

export function timeAgo(ts, now = Date.now()) {
  if (!ts) return "";
  const seconds = Math.round((ts - now) / 1000);
  if (Math.abs(seconds) < 45) return "just now";
  for (const [unit, size] of STEPS) {
    if (Math.abs(seconds) >= size) return rtf.format(Math.round(seconds / size), unit);
  }
  return rtf.format(Math.round(seconds / 60), "minute");
}

const pad = (n) => String(n).padStart(2, "0");

// 2026-10-19 14:32, in local time
export function formatDateTime(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatTime(ts) {
  const d = new Date(ts);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// "Today", "Yesterday" or "Monday, 12 October 2026", for grouping a timeline
export function dayLabel(ts, now = Date.now()) {
  const day = (t) => {
    const d = new Date(t);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  };
  const diff = Math.round((day(now) - day(ts)) / (24 * 3600 * 1000));
  if (diff === 0) return "Today";
  if (diff === 1) return "Yesterday";
  return new Date(ts).toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
